import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 24px;
  color: ${(props) => props.theme.colors.blue.dark};
`;
